
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertTriangle } from "lucide-react";

export function InvalidResetLink() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <Link to="/" className="inline-flex items-center">
            <span className="text-2xl font-bold text-purple-600">OG</span>
            <span className="text-2xl font-bold">MAI</span>
          </Link>
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">Invalid Reset Link</h2>
          <p className="mt-2 text-sm text-gray-600">The password reset link is invalid or has expired</p>
        </div>

        <Card>
          <CardHeader>
            <div className="flex justify-center mb-4">
              <AlertTriangle className="h-12 w-12 text-amber-500" />
            </div>
            <CardTitle className="text-center">Invalid or Expired Link</CardTitle>
            <CardDescription className="text-center">
              This password reset link is invalid or has expired.
            </CardDescription>
          </CardHeader>
          <CardContent className="text-center">
            <p className="mb-4">
              Reset links are valid for a limited time for security reasons. Please request a new
              password reset link to continue.
            </p>
            <Button asChild className="mt-2">
              <Link to="/forgot-password">Request New Link</Link>
            </Button>
          </CardContent>
          <CardFooter className="flex justify-center">
            <p className="text-sm text-gray-600">
              Remember your password?{" "}
              <Link to="/login" className="font-medium text-purple-600 hover:text-purple-500">
                Sign in
              </Link>
            </p>
          </CardFooter>
        </Card>
      </div>
    </div>
  );
}
